import { CustomizeToolTipOutput } from './customize-tool-tip-output.model';


export class CustomizeToolTipSelectByIdOutput implements ICustomizeToolTipSelectByIdOutput {
    status!: number;
    message!: string;
    data!: CustomizeToolTipOutput;

    constructor(data?: ICustomizeToolTipSelectByIdOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.status = _data["status"];
            this.message = _data["message"];
            this.data = _data["data"] ? CustomizeToolTipOutput.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): CustomizeToolTipSelectByIdOutput {
        data = typeof data === 'object' ? data : {};
        let result = new CustomizeToolTipSelectByIdOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status;
        data["message"] = this.message;
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        return data; 
    }
}

export interface ICustomizeToolTipSelectByIdOutput {
    status: number;
    message: string;
    data: CustomizeToolTipOutput;
}

